
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import { DashboardReport } from '../dashboard/dashboard-report';
import { IDashboardReportState } from '@store/slices';

import SideNav from '../company-settings/side-nav/component';

import './style.scss';
import { FormattedMessage } from 'react-intl';

function CompanyTrendsComponent() {
  const { loading } = useSelector((state: { dashboardReportsStore: IDashboardReportState }) => state.dashboardReportsStore);

  return (
    <>
      <section className="pt-3">
        <div className="container vstack gap-4">
          <div className="row">
            <SideNav />
            <div className="col-lg-8 col-xl-9">
              <div className="card shadow-sm border mb-5">
                <div className="card-header border-bottom d-sm-flex justify-content-between align-items-sm-center">
                  <h4 className="card-header-title">
                    <i className="bi bi-columns-gap fa-fw mx-2"></i><FormattedMessage id="overview" />
                  </h4>
                </div>

                <div className="card-body border-bottom">
                  <Spin spinning={loading}>
                    <DashboardReport isV2={true} />
                  </Spin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

const CompanyTrends = CompanyTrendsComponent;
export default CompanyTrends;
